import MuiTextField, {
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material/TextField";
import { Box } from "./Box";

export interface TextFieldProps extends MuiTextFieldProps<"outlined"> {
  componentName: string;
}

export const TextField = ({ componentName, ...props }: TextFieldProps) => {
  const renderBoxShadow = props.helperText ? "none" : "3px 3px 0px 0px #000000";
  return (
    <Box
      componentName={`${componentName}-textfield`}
      sx={{
        boxShadow: renderBoxShadow,
      }}
    >
      <MuiTextField
        {...props}
        data-testid={`${componentName}-textfield`}
        variant="outlined"
        fullWidth={props.fullWidth}
      />
    </Box>
  );
};
